import { gql, useQuery } from '@apollo/client';
import { AnyObject} from '../../models/types';


export interface SdpdsReadOnlyOperationVars {
    operation_name: string;
    payload: any;
}

const SDPDS_READ_ONLY_OPERATION = gql`
    query SdpdsReadOnlyOperation(
            $operation_name: String!,
            $payload: JSON!,
        ){
        sdpdsReadOnlyOperation(
            operation_name: $operation_name,
            payload: $payload
        )
    }
`;


export const useSdpdsReadOnlyOperation = (vars: SdpdsReadOnlyOperationVars) => {
  return useQuery<AnyObject, SdpdsReadOnlyOperationVars>(SDPDS_READ_ONLY_OPERATION, {
    variables: { ...vars },
    errorPolicy: 'all'
  });
};